import {
  GetUserAuditHistoryResponse,
  IdUser,
} from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const getUserAuditHistory = (
  req: Partial<IdUser>
): Promise<GetUserAuditHistoryResponse> =>
  request({
    url: '/service/userv2service/GetUserAuditHistory',
    body: req,
  }).then((r) => r.body);
